import { WsReactBaseService } from '@thewhite/react-base-components';
import { CollectionDTOInterface } from '@thewhite/react-global-module/lib/interfaces';
import { globalConfig } from '../../../config/globalConfig';
import { api } from '../../../config/api';
import { BaseActions } from '../../Global/actions/baseActions';
import { CreateUserParams } from '../interfaces/CreateUserParams';
import { UserPageParams } from '../interfaces/UserPageParams';
import User, { UserDto, UserType } from '../models/user';
import { UserListParams } from '../interfaces/UserListParams';
import { CardUserParams } from '../interfaces/CardUserParams';
import { ResetPasswordParams } from '../interfaces/ResetPasswordParams';

export class UserControllerActions extends BaseActions {
    static DEFAULT_URL = `${globalConfig.api}/auth-service/users/`;
    static api         = api;

    /**
     * Получить список пользователей
     * @param queryParams
     */
    static list = (queryParams: UserListParams): Promise<CollectionDTOInterface<User>> => {
        return UserControllerActions.COLLECTION_API_RESOURCE<UserDto, User>({
            queryParams,
            url: 'list',
            model: User,
            modelType: UserType,
        });
    };

    /**
     * Получить постраничный список пользователей
     * @param params
     */
    static page = (params: UserPageParams): Promise<CollectionDTOInterface<User>> => {
        return UserControllerActions.COLLECTION_API_RESOURCE<UserDto, User>({
            bodyParams: params.bodyParams,
            queryParams: params.queryParams,
            url: 'list',
            model: User,
            modelType: UserType,
            method: WsReactBaseService.POST_METHOD,
        });
    };

    /**
     * Получить пользователя
     * @param id
     */
    static get = (id: string): Promise<User | null> => {
        return UserControllerActions.MODEL_API_RESOURCE<UserDto, User>({
            url: id,
            model: User,
            modelType: UserType,
        });
    };

    /**
     * Создание новой учетной записи пользователя
     * @param bodyParams
     */
    static create = (bodyParams: CreateUserParams): Promise<User | null> => {
        return UserControllerActions.MODEL_API_RESOURCE<UserDto, User>({
            bodyParams,
            model: User,
            url: 'create',
            modelType: UserType,
            method: WsReactBaseService.POST_METHOD,
        });
    };

    /**
     * Редактирование учетной записи пользователя
     * @param userId
     * @param bodyParams
     */
    static update = (userId: string, bodyParams: CardUserParams): Promise<User | null> => {
        return UserControllerActions.MODEL_API_RESOURCE<UserDto, User>({
            bodyParams,
            model: User,
            modelType: UserType,
            url: `${userId}/update`,
            method: WsReactBaseService.POST_METHOD,
        });
    };

    /**
     * Разблокировать пользователя
     * @param userId
     */
    static enable = (userId: string): Promise<User | null> => {
        return UserControllerActions.MODEL_API_RESOURCE<UserDto, User>({
            model: User,
            modelType: UserType,
            url: `${userId}/enable`,
            method: WsReactBaseService.POST_METHOD,
        });
    };

    /**
     * Заблокировать пользователя
     * @param userId
     */
    static disable = (userId: string): Promise<User | null> => {
        return UserControllerActions.MODEL_API_RESOURCE<UserDto, User>({
            model: User,
            modelType: UserType,
            url: `${userId}/disable`,
            method: WsReactBaseService.POST_METHOD,
        });
    };

    /**
     * Сборс паролей пользователя на новый
     * @param userId
     * @param bodyParams
     */
    static resetPassword = (userId: string, bodyParams: ResetPasswordParams): Promise<null> => {
        return UserControllerActions.API_RESOURCE(
            `${userId}/accounts/passwords/reset`,
            WsReactBaseService.POST_METHOD,
            bodyParams,
        );
    };
}
